import axios from 'axios';
import { api, API_BASE_URL } from './api-base';

// Drawings API
export const drawingsApi = {
  // Get drawings for a topic
  getDrawings: async (topicId?: string): Promise<{ data: any[] }> => {
    const response = await api.get('/drawings', { 
      params: topicId ? { topicId } : {} 
    });
    return response.data;
  },

  // Create new drawing
  createDrawing: async (drawingData: {
    topicId: string;
    commentId?: string;
    geometry: string; // GeoJSON string
    style: any;
    properties?: Record<string, any>;
    type: 'POINT' | 'LINE' | 'POLYGON';
  }): Promise<any> => {
    const response = await api.post('/drawings', drawingData);
    return response.data;
  },

  // Update existing drawing
  updateDrawing: async (id: string, drawingData: {
    geometry?: string; // GeoJSON string
    style?: any;
    properties?: Record<string, any>;
    type?: 'POINT' | 'LINE' | 'POLYGON';
  }): Promise<any> => {
    const response = await api.put(`/drawings/${id}`, drawingData);
    return response.data;
  },

  // Delete drawing
  deleteDrawing: async (id: string): Promise<void> => {
    await api.delete(`/drawings/${id}`);
  },
};

// Reports API
export const reportsApi = {
  createReport: async (payload: {
    targetType: 'TOPIC' | 'COMMENT';
    targetId: string;
    reason?: string;
  }): Promise<{ message: string; reportId: string }> => {
    const response = await api.post('/reports', payload);
    return response.data;
  }
};

// Admin API (moderator tools)
export const adminApi = {
  // List pending reports (unresolved)
  getReports: async (): Promise<{ data: any[] }> => {
    const res = await api.get('/admin/reports');
    return res.data;
  },
};

// Health check
export const healthApi = {
  check: async (): Promise<{ status: string; timestamp: string; environment: string }> => {
    const response = await axios.get(`${API_BASE_URL}/health`);
    return response.data;
  },
};
